import { useTranslation } from 'react-i18next'
import { percentChange } from './progressMath'

/**
 * "+24%" in green, "−12%" in red, "New" when there was nothing before.
 * Renders nothing when both periods are empty.
 */
export function DeltaChip({ current, previous }: { current: number; previous: number }) {
  const { t } = useTranslation()
  const change = percentChange(current, previous)
  if (change === null) return null

  const up = change === 'new' || change > 0
  const flat = change !== 'new' && change === 0
  const tone = flat
    ? 'bg-foreground/5 text-foreground/50'
    : up
      ? 'bg-success/15 text-success-700'
      : 'bg-danger/10 text-danger'
  const label =
    change === 'new'
      ? t('progress.deltaNew')
      : `${change > 0 ? '+' : change < 0 ? '−' : ''}${Math.abs(change)}%`

  return (
    <span
      data-testid="delta-chip"
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold ${tone}`}
    >
      {label}
    </span>
  )
}
